import Application from "./application/Application";
import Demo from './demo/DemoSettings';
import License from "./license/License";
import Notification from "./notification/Notifications";
import User from './user/UserSettings';

export default { Application, License, Notification, Demo, User };
